var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInckdIcon = function SvgInckdIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96 0C1.325 0 0 1.356 0 3.033c0 1.676 1.324 3.032 2.96 3.032 1.637 0 2.961-1.356 2.961-3.032C5.921 1.356 4.597 0 2.961 0ZM11.194 16.773c-1.55 0-2.807 1.289-2.807 2.875s1.258 2.875 2.806 2.875c1.549 0 2.807-1.289 2.807-2.875s-1.254-2.875-2.806-2.875ZM.576 20.143l2.82 2.699h1.949V7.962H.576v12.18Z",
    fill: "#fff"
  })));
};

export default SvgInckdIcon;